<h1>Custom Fields</h1>

<div class="toolbar actions-bar" fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="start start">
  <button appAuthorizeControl="edit||eventmang" type="button" mat-raised-button color="accent"
    matTooltip="Add new record" [routerLink]="[0]" data-testid="New Event">
    <mat-icon class="">add</mat-icon>Add Custom Field
  </button>

  <button type="button" mat-stroked-button
      *ngIf="(getSelectedSectionRecords().length)"
    [matMenuTriggerFor]="menu" matTooltip="Actions">
    <mat-icon>more_vert</mat-icon>Actions 
  </button>
  <mat-menu #menu="matMenu" class="mat-dropdown-menu">
    <button type="button" mat-menu-item
      (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
    <button type="button" mat-menu-item
      *ngIf="(getSelectedSectionRecords().length)">
      {{ getSelectedSectionRecords().length }} Selected
    </button>
  </mat-menu>

  <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text" (input)="onSearch($event)" placeholder="Search Custom Fields" #searchInput
      data-testid="Search Bar" [formControl]="searchControl" />
    <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
      (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<ng-container *ngIf="viewModel$ | async as viewModel">

  <table mat-table [dataSource]="viewModel.fields" matSort (matSortChange)="onSort($event)" matSortDisableClear
    [matSortStart]="'asc'">    

    <ng-container matColumnDef="select" data-testid="Check Box">
      <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td class="no-ellipsis" mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Field Name Column -->
    <ng-container matColumnDef="FieldName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Field Name" [resizeColumn]="true">
        Field Name
      </th>
      <td mat-cell *matCellDef="let record">{{ record.FieldName }}</td>
    </ng-container>

    <!-- Display Label Column -->
    <ng-container matColumnDef="DisplayLabel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Display Label" [resizeColumn]="true">
        Display Label
      </th>
      <td mat-cell *matCellDef="let record">{{ record.DisplayLabel }}</td>
    </ng-container>

    <!-- Vertex Type Column -->
    <ng-container matColumnDef="VertexType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Vertex Type" [resizeColumn]="true">
        Vertex Type
      </th>
      <td mat-cell *matCellDef="let record">{{ record.VertexType }}</td>
    </ng-container>

    <!-- Field Type Column -->
    <ng-container matColumnDef="FieldType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Field Type" [resizeColumn]="true">
        Field Type
      </th>
      <td mat-cell *matCellDef="let record">{{ record.FieldType }}</td>
    </ng-container>
    <ng-container matColumnDef="DisplayOrder">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Display Order" [resizeColumn]="true">
        Display Order
      </th>
      <td mat-cell *matCellDef="let record">{{ record.DisplayOrder }}</td>
    </ng-container>

    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let record">
        <button mat-icon-button color="primary" [routerLink]="[record.Id]" matTooltip="Edit Field">
          Edit
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <table *ngIf="!viewModel.fields.length">
    <tr>
      <td class="no-records" [attr.colspan]="displayedColumns.length">
        <h2>No Records Found</h2>
      </td>
    </tr>
  </table>

  <!-- pager -->
  <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
    [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)" *ngIf="viewModel.fields.length"
    showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
  </mat-paginator>
</ng-container>